<template>
  <div
    :class="{
      'reports-dashboard-metric': true,
      'is-secondary': small,
    }"
    :style="{
      color: `var(--${color})`,
    }"
  >
    <div class="amount">
      <span v-if="prefix">{{ prefix }}</span>
      <hl-Currency v-if="format === 'currency'" :amount="value" />
      <span v-else-if="format === 'percent'">{{ value }}%</span>
      <span v-else>{{ value }}</span>
    </div>
    <div class="legend">{{ legend }}</div>
  </div>
</template>

<script>
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';

export default {
  name: 'ReportsDashboardMetric',

  components: {
    'hl-Currency': Currency,
  },

  props: {
    value: Number,
    legend: String,
    small: Boolean,
    prefix: String,
    format: {
      type: String,
      default: 'number',
    },
    color: {
      type: String,
      default: 'dark',
    },
  },
};
</script>

<style scoped lang="scss">
.reports-dashboard-metric {
  text-align: center;

  > .amount {
    font-size: 2rem;
    line-height: 1;
    font-weight: 300;
  }

  > .legend {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  &.is-secondary {
    padding: 0.5rem;

    > .amount {
      font-size: 1.2rem;
    }
  }
}
</style>
